import { AxiosResponse, AxiosError } from 'axios';

// Constants
import {
    VARIETY_CREATE_REQUESTED,
    VARIETY_CREATE_SUCCEEDED,
    VARIETY_CREATE_FAILED,
    VARIETIES_SET,
    VARIETY_UPDATE_REQUESTED,
    VARIETY_UPDATE_SUCCEEDED,
    VARIETY_UPDATE_FAILED
} from './constants';

// Types
import {
    RequestCreateVarietyAction,
    SucceededCreateVarietyAction,
    FailedCreateVarietyAction,
    VarietyCreatePayload,
    VarietiesState,
    SetVarietiesAction,
    VarietyUpdatePayload,
    RequestVarietyUpdateAction,
    SucceededVarietyUpdateAction,
    FailedUpdateVarietyAction
} from './types';

export function requestCreateVariety(
    payload: VarietyCreatePayload
): RequestCreateVarietyAction {
    return {
        type: VARIETY_CREATE_REQUESTED,
        payload
    };
}

export function succeededCreateVariety(
    response: AxiosResponse
): SucceededCreateVarietyAction {
    return {
        type: VARIETY_CREATE_SUCCEEDED,
        payload: response
    };
}

export function requestUpdateVariety(
    payload: VarietyUpdatePayload
): RequestVarietyUpdateAction {
    return {
        type: VARIETY_UPDATE_REQUESTED,
        payload
    };
}

export function succeededUpdateVariety(
    response: AxiosResponse
): SucceededVarietyUpdateAction {
    return {
        type: VARIETY_UPDATE_SUCCEEDED,
        payload: response
    };
}

export function failedCreateVariety(
    error: AxiosError
): FailedCreateVarietyAction {
    return {
        type: VARIETY_CREATE_FAILED,
        payload: error,
        error: true
    };
}

export function failedUpdateVariety(
    error: AxiosError
): FailedUpdateVarietyAction {
    return {
        type: VARIETY_UPDATE_FAILED,
        payload: error,
        error: true
    };
}

export function setVarieties(varieties: VarietiesState): SetVarietiesAction {
    return {
        type: VARIETIES_SET,
        payload: varieties
    };
}
